<template>
  <div id="eachrunpanel" class="container row text-center">
    <div v-if="isMobile" class="col-md-12 col-lg-6">
      <PieChart
      :data="each_run_total"
      :innerRadius="50"
      :outerRadius="140"
      :padAngle="0.05"
      :colorScheme="'schemeAccent'"
      :isMobile="isMobile"
      :height="700" />
    </div>
    <div v-else class="col-md-12 col-lg-6">
      <PieChart
      :data="each_run_total"
      :innerRadius="50"
      :outerRadius="140"
      :padAngle="0.05"
      :colorScheme="'schemeAccent'"
      :isMobile="isMobile" />
    </div>
    <div class="col-md-12 col-lg-6 d-lg-flex flex-lg-column justify-content-center">
      <h2>Score Distribution</h2>
    </div>
	</div>
</template>

<script>
import each_run_seasons_wise from "../assets/each_run_seasons_wise.json";

export default {
  name: "EachRunPanel",
  components: {
    PieChart: () => import("./PieChart.vue")
  },
  data() {
    return {
      each_run_total: each_run_seasons_wise[9]["each_runs"],
      isMobile: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener(
        "orientationchange",
        this.detectOrientationChange
      );
    });
  },
  created() {
    this.detectOrientationChange();
  },
  methods: {
    detectOrientationChange() {
      // switch (window.orientation) {
      //   case 0:
      //     // landscape
      //     this.isMobile = true;
      //     break;
      //   default:
      //     // portrait
      //     this.isMobile = false;
      //     break;
      // }

      if (window.screen.width > 767) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    }
  }
};
</script>

<style >
#eachrunpanel {
  margin-bottom: 20px;
  border-bottom: 1px grey solid;
}
</style>
